module.exports = __webpack_public_path__ + "static/media/logo-white.eec7c7f6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-white.svg
// module id = 1544
// module chunks = 0